/**
 * src/admin-ui/src/pages/Login.styles.ts
 *
 * Responsive login and registration page styles.
 */

import { Box, Button, Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const BOTTOM_BAR_HEIGHT = 42;

export const LoginViewport = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  height: `calc(100vh - ${BOTTOM_BAR_HEIGHT}px)`,
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.background.paper,
  overflow: "auto",
  "@supports (height: 100dvh)": {
    height: `calc(100dvh - ${BOTTOM_BAR_HEIGHT}px)`,
  },
}));

export const LoginBottomBar = styled(Box)(({ theme }) => ({
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  height: BOTTOM_BAR_HEIGHT,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  paddingRight: theme.spacing(1.5),
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.divider}`,
  zIndex: theme.zIndex.appBar,
}));

export const LoginPaper = styled(Paper)(({ theme }) => ({
  display: "flex",
  width: "100%",
  maxWidth: 440,
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(4),
  "& > .MuiAlert-root": {
    width: "100%",
    marginBottom: theme.spacing(3),
  },
  "& > .MuiDivider-root": {
    marginBlock: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2.5, 2),
    marginHorizontal: theme.spacing(2),
  },
}));

export const Brand = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.main,
  "& .MuiSvgIcon-root": {
    fontSize: 40,
  },
}));

export const AuthForm = styled("form")({
  width: "100%",
});

export const SubmitButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  paddingBlock: theme.spacing(1.5),
  fontSize: "1.1rem",
  fontWeight: 700,
}));

export const HelperText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(3),
  textAlign: "center",
}));

export const AuthSwitch = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  textAlign: "center",
}));

export const AuthSwitchLink = styled("button")(({ theme }) => ({
  appearance: "none",
  padding: 0,
  border: 0,
  background: "none",
  color: theme.palette.primary.main,
  cursor: "pointer",
  font: "inherit",
  fontWeight: 700,
  textDecoration: "none",
}));

export const DebugActions = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  gap: theme.spacing(1),
  flexWrap: "wrap",
  "& .MuiButton-root": {
    color: theme.palette.text.secondary,
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    "& .MuiButton-root": {
      width: "100%",
    },
  },
}));
